import React from 'react';
import { Table, Row, Col } from '@digital/ui';
import { currencyFormat } from '@app/helpers/numbers';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

const ParcelasPagamentoTable = (props: any) => {
    const { arquivos } = props;

    const column = [
        {
            title: 'Número da Parcela',
            dataIndex: 'parcelaCobrancaNumero',
        },
        {
            title: 'Data Previsão Pagamento',
            dataIndex: 'dataPrevisaoPagamento',
            render: (text, record) => moment(record.dataPrevisaoPagamento).format(dateTimeFormat)
        },
        {
            title: 'Valor da Parcela',
            dataIndex: 'valor',
            render: (text, record) => currencyFormat(record.valor)
        }
    ];

    return (
        <>
            <Row>
                <Col>
                    <Table columns={column} dataSource={arquivos} />
                </Col>
            </Row>
        </>
    );
};
export default ParcelasPagamentoTable;